import styled from 'styled-components';
import { GenericBlockToggle } from '../../../shared/components/BlockToolbarComponent';
export var HeaderThreeBlockToggle = styled(GenericBlockToggle).withConfig({
  displayName: "BlockToolbarComponentstyle__HeaderThreeBlockToggle",
  componentId: "sc-1jdbg6r-0"
})(["padding-top:5px;"]);